import Component from "@glimmer/component"

export default class GoogleClassroomCreateAttachmentMenuComponent extends Component {}
